import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Dashboard ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Old version ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Services ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Subscription ")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Uniswap ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" About XRT ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Substrate Portal ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Subscan ")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Polkassembly ")

export function render(_ctx, _cache) {
  const _component_robo_sidebar_item = _resolveComponent("robo-sidebar-item")
  const _component_robo_sidebar = _resolveComponent("robo-sidebar")
  const _component_robo_grid_item = _resolveComponent("robo-grid-item")

  return (_openBlock(), _createBlock(_component_robo_grid_item, {
    "media-mobile": "collapse-left",
    "collapse-text": "Navigation"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_robo_sidebar, {
        title: "Dapp",
        icon: "house"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_sidebar_item, {
            router: { name: 'dashboard' },
            current: ""
          }, {
            default: _withCtx(() => [
              _hoisted_1
            ]),
            _: 1
          }),
          _createVNode(_component_robo_sidebar_item, { href: "https://old.dapp.robonomics.network/" }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_robo_sidebar, {
        title: "IoT services",
        icon: "cloud"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_sidebar_item, { router: { name: 'services' } }, {
            default: _withCtx(() => [
              _hoisted_3
            ]),
            _: 1
          }),
          _createVNode(_component_robo_sidebar_item, { router: { name: 'subscription-bid' } }, {
            default: _withCtx(() => [
              _hoisted_4
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_robo_sidebar, {
        title: "Tokenomics",
        icon: "chart-pie"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_sidebar_item, { href: "https://app.uniswap.org/#/swap?inputCurrency=0x7de91b204c1c737bcee6f000aaa6569cf7061cb7&outputCurrency=0xc02aaa39b223fe8d0a0e5c4f27ead9083c756cc2" }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_robo_sidebar_item, { href: "https://robonomics.network/xrt/" }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_robo_sidebar, {
        title: "Tools",
        icon: "circle-exclamation"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_robo_sidebar_item, { href: "https://polkadot.js.org/apps/?rpc=wss%3A%2F%2Fkusama.rpc.robonomics.network%2F#/explorer" }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }),
          _createVNode(_component_robo_sidebar_item, { href: "https://robonomics.subscan.io/" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_robo_sidebar_item, { href: "https://robonomics.polkassembly.io" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}